import { SearchIcon } from '@repo/icons';
import { SideMenuItem } from '@repo/ui/side-menu-item';
import { useTranslations } from 'next-intl';
import { useAppStore } from '@/providers/AppStoreProvider';

type SearchProps = {
  sidebarOpen: boolean;
};

const Search = ({ sidebarOpen }: SearchProps) => {
  const t = useTranslations('sidebar-left');

  const { setIsSearchCasinoGamesDialogOpen, isSearchCasinoGamesDialogOpen } = useAppStore((state) => ({
    setIsSearchCasinoGamesDialogOpen: state.setIsSearchCasinoGamesDialogOpen,
    isSearchCasinoGamesDialogOpen: state.isSearchCasinoGamesDialogOpen,
  }));

  const handleClick = () => {
    setIsSearchCasinoGamesDialogOpen(true);
  };

  return (
    <SideMenuItem
      text={sidebarOpen && t('search')}
      Icon={<SearchIcon />}
      className="border vt-input-default-bg-normal vt-input-default-stroke-normal"
      isActive={isSearchCasinoGamesDialogOpen}
      onClick={handleClick}
    />
  );
};

export default Search;
